export default {"src":"/_next/static/media/circleHeart_24.32d4fbe1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};